export default __webpack_public_path__ + "static/threat-operational-img-6f1b777fdb202dc87f471554fafcddf9.svg";